import { useState } from "react";
import axios from "axios";
import { CgClose } from "react-icons/cg";
import Input from "../Form/Input"
import TextAreaEditor from "../Form/TextAreaEditor"
import FilePicker from "../FilePicker"
import Modal from "../../components/Modal"
import { ENROLMENT_API_END_POINT, END_POINT } from "../../utils/constant";
import ImageWithFallback from "../../plateform/components/ImageWithFallback";
import Notification from "../Notification"
import ButtonBlack from "../Buttons/ButtonBlack";
import ConfettiCanvas from "../Confetti";
import CongratsModal from './CongratsModal';

const EnrollmentModal = ({ isOpen, onClose, onSubmitSuccess,  user, training }) => {
  const [formData, setFormData] = useState({
    email: "",
    message: "",
    training_id : training?.id,
    user_id: user?.id
  });
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")
  const [showNotif, setShowNotif] = useState({
    show: false,
    message:"Une erreur est survenue",
    variant: "danger"
  })
  const [showConfetti, setshowConfetti] = useState(false)
  const [showCongratsModal, setshowCongratsModal] = useState(false)

  // Gérer les changements dans les champs
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  const handleFileChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  }

  // Soumettre le formulaire
  const handleSubmit = async () => {
    setLoading(true);
    
    setError("");
    const formDataToSend = new FormData()
    formDataToSend.append("training_id", training?.id)
    formDataToSend.append("user_id", user.id);
    formDataToSend.append("message", formData.message)

    console.log("Application submitted", formData)
    for (let pair of formDataToSend.entries()) {
      console.log(`${pair[0]}: ${pair[1]}`)
    }

    await axios.post(ENROLMENT_API_END_POINT+"/save", formDataToSend,
      { headers: {
        "Content-Type": "multipart/form-data",
      }
      }
    )
    .then((response)=>{
      // setShowNotif({...showNotif, variant: "success", message: response.data?.message, show: true})
      setshowCongratsModal(true)
      setLoading(false);
      setshowConfetti(true)

      setTimeout(() => {
        setshowConfetti(false)
        // setShowNotif({...showNotif, show: false})
      }, 3000);

      // setTimeout(() => {
        onClose();
      // }, 4000);
      
    })
    .catch((error)=>{
      console.log(error)
      setShowNotif({...showNotif, variant: "danger", message: error.data?.message || "Une erreur est survenue lors de l'enregistrement", show: true})
      setLoading(false);
    })     
   
  };

  return (
    <>
    <Modal  isOpen={isOpen} onClose={onClose}>
      <div className="modal-content">
        <div className="flex items-center justify-between py-2 px-4">
          <p>S'inscrire à une formation </p>
          <button onClick={onClose} className="px-2 py-2 rounded-md border text-primary-black">
            <CgClose />
          </button>
        </div>
        <hr className="mb-6" />

        <div className="px-6 space-y-4 mb-4">
          <div className="flex gap-4">        
            <ImageWithFallback src={END_POINT+ "/storage"+ training?.user?.organisation_profile?.logo} className="  object-cover bg-neutral-100 rounded-full w-10 h-10" defaultType="logo"/>
            <div className="flex flex-col justify-between items-start">
              <p>{training?.title}</p>
              <p>{training?.user?.organisation_profile?.company_name || "Entreprise anonyme"}</p>
            </div>
          </div>

          <Input
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          <TextAreaEditor
            label="Message"
            name="message"
            value={formData.message}
            setValue={(value)=>setFormData({...formData, message: value})}
          />
          {/* <FilePicker onFileChange={handleFileChange} /> */}
        </div>

        <div className="flex items-center justify-end p-6">
          <ButtonBlack
            onClick={handleSubmit}
            DefaultClassName="py-2 px-6 rounded-sm shadow w-40"
            disabled={loading}
          >
            {loading ? "Envoi..." : "Envoyer"}
          </ButtonBlack>
        </div>
      </div>
       </Modal>

       <Notification variant={showNotif.variant} text={showNotif.message} isOpen={showNotif.show} setIsOpen={()=>setShowNotif({...showNotif, show: false})} />
       <ConfettiCanvas show={showConfetti} />
       <CongratsModal show={showCongratsModal} onClose={()=>setshowCongratsModal(false)} />
    </>
  );
};

export default EnrollmentModal;
